import { render } from "./MyProductsPage.vue?vue&type=template&id=61d6ad34&scoped=true"
import script from "./MyProductsPage.vue?vue&type=script&lang=js"
export * from "./MyProductsPage.vue?vue&type=script&lang=js"

import "./MyProductsPage.vue?vue&type=style&index=0&id=61d6ad34&lang=css"
import "./MyProductsPage.vue?vue&type=style&index=1&id=61d6ad34&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d6ad34"]])

export default __exports__